import { Icon } from '@iconify/vue';
import { h, type CSSProperties } from 'vue';

export default {
  renderIcon(icon: string, style: CSSProperties = { fontSize: 14 }) {
    return () => h(Icon, { icon, style });
  },

  renderIconWithProps(props: any) {
    return () => h(Icon, { ...props });
  },
};
